import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { orderBy, get } from 'lodash-es';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Dropdown from 'reactstrap/lib/Dropdown';
import DropdownItem from 'reactstrap/lib/DropdownItem';
import DropdownToggle from 'reactstrap/lib/DropdownToggle';
import DropdownMenu from 'reactstrap/lib/DropdownMenu';
import dateFormat from 'dateformat';

import './user-comments.scss';

export const SORT_ORDER_ASC = 'asc';
export const SORT_ORDER_DESC = 'desc';
export const OLDEST_TO_NEWEST = 'Oldest to Newest';
export const NEWEST_TO_OLDEST = 'Newest to Oldest';

export class UserComments extends Component {
  static propTypes = {
    comments: PropTypes.arrayOf(
      PropTypes.shape({
        authorName: PropTypes.string,
        created: PropTypes.number,
        updated: PropTypes.number,
        text: PropTypes.string,
        dealerComment: PropTypes.bool,
      })
    ).isRequired,
    reviewTitle: PropTypes.string.isRequired,
    reviewId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      comments: orderBy(this.props.comments, ['created'], [SORT_ORDER_DESC]),
      isSortDropdownOpen: false,
      order: SORT_ORDER_DESC,
      sortLabel: NEWEST_TO_OLDEST,
    };
  }

  componentDidUpdate(prevProps) {
    const { comments } = this.props;

    if (get(prevProps, 'comments.length') !== get(comments, 'length')) {
      this.updateComments();
    }
  }

  updateComments = () =>
    this.setState({
      comments: orderBy(this.props.comments, ['created'], [this.state.order]),
    });

  sortComments = (order, sortLabel) => () => {
    if (this.state.order !== order) {
      this.setState({
        order,
        sortLabel,
        comments: orderBy(this.props.comments, ['created'], [order]),
      });
    }
  };

  toggleSortDropdown = () => {
    this.setState(prevState => ({ isSortDropdownOpen: !prevState.isSortDropdownOpen }));
  };

  render() {
    const { reviewTitle, reviewId } = this.props;
    const { comments, isSortDropdownOpen, sortLabel } = this.state;
    const commentsLength = comments.length;

    return (
      <Row className="user-comments text-gray-darker">
        <Col xs={12} md={6}>
          <span className="heading-4">
            Showing {commentsLength} {commentsLength === 1 ? 'comment' : 'comments'}
          </span>
        </Col>
        <Col xs={12} md={6} className="text-md-end medium mt-1 mt-md-0">
          <span className="me-0_25">Sort by:</span>
          <Dropdown isOpen={isSortDropdownOpen} toggle={this.toggleSortDropdown} className="d-inline-block">
            <DropdownToggle
              caret
              className="d-inline-block pe-1_5 ps-0 pt-0 pb-0 align-baseline medium text-gray-darker fw-normal bg-none text-transform-none"
            >
              {sortLabel}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem onClick={this.sortComments(SORT_ORDER_ASC, OLDEST_TO_NEWEST)}>
                Oldest to Newest
              </DropdownItem>
              <DropdownItem onClick={this.sortComments(SORT_ORDER_DESC, NEWEST_TO_OLDEST)}>
                Newest to Oldest
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Col>
        <Col xs={12} className="user-comments-list">
          {comments.map(({ created, authorName, dealerComment, text }) => (
            <div key={created} className="mt-1_5">
              <div className="mb-1">
                <span className="user-comment-author">{authorName}</span> on
                <span className="user-comment-creation-date"> {dateFormat(created, 'mm/dd/yyyy')}</span>
                {dealerComment && <div className="fw-bold small">Dealer Response</div>}
              </div>
              <div className="mb-1">{text}</div>
              <a
                className="text-primary-darker small text-underline"
                href={`https://help.edmunds.com/hc/en-us/requests/new?ticket_form_id=2343&ticket[subject]=Report%20comment%20(${reviewId})%20to%20Edmunds.com%20for%20investigation&ticket[description]=I%20am%20reporting%20this%20comment%20on%20%22${reviewTitle}%22%20posted%20by%20${authorName}%20because...`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Report
              </a>
              <hr />
            </div>
          ))}
        </Col>
      </Row>
    );
  }
}
